import { Link } from 'react-router-dom';

export const DropdownMenu = ({ closeDropdownMenu, values, axisX }) => {
  return (
    <> 
      <div 
        className="dropdown-menu-wrapper"
        onClick={closeDropdownMenu}
      ></div>
      <div 
        className="dropdown-menu" 
        style={{ left : axisX }}
      >
        {
          values.map(item => {
            return <div className="dropdown-menu-item" key={item.id}>
                      <div className="left-part-dropdown">
                        <img src={item.img} alt="" />
                      </div>
                      <div 
                        className="right-part-dropdown"
                      >
                        <div className="title">
                          {item.title}
                        </div>
                        <div className="link-to-page">
                          <Link 
                            to={item.url}
                            onClick={closeDropdownMenu}
                          >
                            Read More
                          </Link>
                          <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/arrow-right.png`} alt="" />

                        </div>
                      </div>
                    </div>
          })
        }
      </div>
    </>
  );
}
